import { establishments, events } from '@solarApiResources';
import { venus } from '@/api/axios-api';
import { eventEntity } from '@secret-society/entities';

/**
 *
 * @param list
 * @returns {*[]}
 */
export const filterEventsFromEstablishmentList = (list = []) => list.filter((l) => l.computed.isLive || l.computed.isPassed());

/**
 *
 * @param idEvent
 * @returns {Promise<EventTypes.RootObject>}
 */
export const fetchEvent = async (idEvent) => {
  const { data } = await venus.request({
    ...events.getEvent,
    queryParams: { id: idEvent },
    bag: {
      params: {
        include: ['attachments', 'establishment'],
      },
    },
  });

  return eventEntity.formatFromApi(data);
};

/**
 *
 * @param idEstablishment
 * @param options
 * @returns {Promise<{data: *[], paging}>}
 */
export const fetchEventsFromEstablishment = async (idEstablishment, options = {}) => {
  const { data, paging } = await venus.request({
    url: establishments.events.url,
    method: establishments.events.method,
    bag: {
      page: options?.page,
      size: options?.size,
      sort: options?.sort || { start_at: 'desc' },
      params: {
        include: ['attachments'],
      },
    },
    queryParams: { id: idEstablishment },

  });

  return {
    data: filterEventsFromEstablishmentList(data.map(eventEntity.formatFromApi)),
    paging,
  };
};
